/** DTOs keys for "storage" module */
export enum StorageDtoKeyEnum {
  /** S3 storage bucket own filters */
  BUCKET_FILTERS_DTO = 'storage/bucket-filters.dto',
  /** S3 storage bucket find many API query parameters */
  BUCKET_FIND_MANY_QUERY_DTO = 'storage/bucket-find-many-query.dto',
  /** S3 storage bucket find one API query parameters */
  BUCKET_FIND_ONE_QUERY_DTO = 'storage/bucket-find-one-query.dto',
  /** S3 storage bucket response body */
  BUCKET_FIND_DTO = 'storage/bucket-find.dto',
  /** S3 storage bucket create and update APIs request body */
  BUCKET_FORM_DTO = 'storage/bucket-form.dto',
  /** S3 storage bucket find many API response body */
  BUCKET_PAGE_DTO = 'storage/bucket-page.dto',
  /** S3 storage bucket partial update API request body */
  BUCKET_PARTIAL_FORM_DTO = 'storage/bucket-partial-form.dto',
  /** S3 storage bucket selection settings */
  BUCKET_SELECT_DTO = 'storage/bucket-select.dto',
  /** S3 storage bucket sorting settings */
  BUCKET_SORT_DTO = 'storage/bucket-sort.dto',
  /** Common files statistics response body */
  STAT_FIND_DTO = 'storage/stat-find.dto',
  /** S3 storage find many API query parameters */
  STORAGE_FIND_MANY_QUERY_DTO = 'storage/storage-find-many-query.dto',
  /** S3 storage find one API query parameters */
  STORAGE_FIND_ONE_QUERY_DTO = 'storage/storage-find-one-query.dto',
  /** S3 storage credentialis response body */
  STORAGE_FIND_DTO = 'storage/storage-find.dto',
  /** S3 storage credentials create and update APIs request body */
  STORAGE_FORM_DTO = 'storage/storage-form.dto',
  /** S3 storage credentials find many API response body */
  STORAGE_PAGE_DTO = 'storage/storage-page.dto',
  /** S3 storage credentials partial update API request body */
  STORAGE_PARTIAL_FORM_DTO = 'storage/storage-partial-form.dto',
  /** S3 storage selection settings */
  STORAGE_SELECT_DTO = 'storage/storage-select.dto',
  /** S3 storage sorting settings */
  STORAGE_SORT_DTO = 'storage/storage-sort.dto',
  /** File own filters */
  FILE_FILTERS_DTO = 'storage/file-filters.dto',
  /** File descriptor find many API query parameters */
  FILE_FIND_MANY_QUERY_DTO = 'storage/file-find-many-query.dto',
  /** File descriptor response body */
  FILE_FIND_DTO = 'storage/file-find.dto',
  /** File descriptor find many API response body */
  FILE_PAGE_DTO = 'storage/file-page.dto',
  /** Single file APIs URL parameters */
  FILE_PARAMS_DTO = 'storage/file-params.dto',
  /** File descriptor selection settings */
  FILE_SELECT_DTO = 'storage/file-select.dto',
  /** File descriptor sorting settings */
  FILE_SORT_DTO = 'storage/file-sort.dto',
  /** File upload API query parameters */
  FILE_UPLOAD_QUERY_DTO = 'storage/file-upload-query.dto',
  /** Storage commentary file response body */
  COMMENTARY_FILE_FIND_DTO = 'storage/commentary-file-find.dto',
  /** Storage commentary files slice (JSON "page") response body */
  COMMENTARY_FILE_PAGE_DTO = 'storage/commentary-file-page.dto',
}
